import { Block, ButtonProps, Flex, OfflineBanner } from '@aloft/toolkit-sui';

import { PropsWithChildren, useState } from 'react';

import { GlobalContentfulAlerts } from '../components/GlobalContentfulAlerts/GlobalContentfulAlerts.js';
import { MainHeader } from '../components/MainHeader/MainHeader.js';
import { ServerDownBanner } from '../components/ServerDownBanner.js';
import { TrialEndingBanner } from '../components/TrialEndingBanner.js';
import { UnsupportedDeviceAlert } from '../components/UnsupportedDeviceAlert.js';
import { useIsScreenSupported } from '../controller/hooks/useIsScreenSupported.js';
import { UnsupportedDeviceOverride } from './UnsupportedDeviceOverride.js';

type PageLayoutProps = PropsWithChildren<{
  title: string;
  showNav?: boolean;
  showBackButton?: boolean;
  onBackButtonClick?: () => void;
  primaryActionProps?: ButtonProps;
}>;

export const MainLayout = ({
  title,
  showNav = true,
  showBackButton = false,
  onBackButtonClick,
  primaryActionProps,
  children,
}: PageLayoutProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const isScreenSupported = useIsScreenSupported(['tablet', 'desktop', 'unconstrained']);

  return (
    <Flex flexDirection="column" height="100vh" overflow="hidden" width="100vw">
      <Block flexShrink={1}>
        <TrialEndingBanner />
      </Block>

      <Block flexShrink={1}>
        <GlobalContentfulAlerts />
      </Block>

      <Block flexShrink={1}>
        <UnsupportedDeviceAlert />
      </Block>

      <Block flexShrink={1}>
        <OfflineBanner />
      </Block>

      <Block flexShrink={1}>
        <ServerDownBanner />
      </Block>

      <MainHeader
        title={title}
        isCollapsed={isCollapsed}
        onCollapseToggle={showNav ? () => setIsCollapsed(!isCollapsed) : undefined}
        primaryActionProps={primaryActionProps}
        showBackButton={showBackButton}
        onBackButtonClick={onBackButtonClick}
      />
      <Flex flexGrow={1} overflow="hidden" width="100%">
        <Block flexGrow={1} height="100%" overflow="hidden">
          {isScreenSupported ? children : <UnsupportedDeviceOverride />}
        </Block>
      </Flex>
    </Flex>
  );
};
